// extracted by mini-css-extract-plugin
export default {"wrapper":"difficulty_wrapper__J1B5B","title":"difficulty_title__1BG-q","value":"difficulty_value__aNgIM","content":"difficulty_content__K86V3","item":"difficulty_item__kGD7v"};